import React from 'react';
export function FinalCTA() {
  return <section className="py-20 bg-gold-500" data-id="element-37">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-38">
        <h2 className="text-3xl md:text-5xl font-extrabold text-navy-900 mb-6" data-id="element-39">
          No Dejes Que Un Mal Crédito Te Detenga Más
        </h2>
        <p className="text-xl text-navy-800 mb-10 font-medium" data-id="element-40">
          La oferta del 82% de descuento termina pronto. Empieza a reparar tu
          crédito hoy mismo por solo $6.99.
        </p>
        <a href="#pricing" className="inline-block px-10 py-5 text-xl font-extrabold rounded-xl text-white bg-navy-900 hover:bg-navy-800 transition-colors shadow-xl hover:shadow-2xl transform hover:-translate-y-1" data-id="element-41">
          Sí, Quiero Acceso Inmediato
        </a>
      </div>
    </section>;
}